module.exports = __webpack_public_path__ + "static/media/baseImage.de0bc1c1.bin";